// extracted by mini-css-extract-plugin
export default {"container":"SuppliersListItem_container__qVMVV","checkbox":"SuppliersListItem_checkbox__lFGpZ","wrapper":"SuppliersListItem_wrapper__OBNWG","text":"SuppliersListItem_text__rnJ2s"};